import React, { useEffect, useState,useRef } from "react";
import { useSelector } from "react-redux";
import { menuItem } from "../../assets/config";
import { ListBox } from "primereact/listbox";
import { useNavigate } from "react-router-dom";
import { Accordion, AccordionTab } from "primereact/accordion";
import styled from "styled-components";
import useScreenSize from "../../assets/useScreenSize";
import "./menu.css";

const newLocal = `
  .p-accordion-header-link {
    border-radius: 0;
    background-color: #fff;
    border: 0;
    i {
      // margin-top: 8px;
      position: absolute;
      right: 0.5em;
      top: 50%;
    }
  }

  .p-accordion-tab-active {
    .p-accordion-header-link,
    .p-accordion-content {
      background: #f5f4f1;
    }
  }

  .p-accordion .p-accordion-tab {
    margin-bottom: 0px;
  }
`;
let CustomAccordianDiv = styled.divnewLocal;

let MenuContainerDiv = styled.div`
  .p-listbox-list {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    padding-left:0px !important
  
  
  }

  .p-listbox .p-listbox-list  .p-highlight {
    color: #000;
    font-weight: 600;

    
  }
    .p-listbox-list{
    // background-color:red;
    // padding-left:3pc !important;
    display:flex;
    flex-direction:column;
    // padding:0 !importent

    }

   
`;
export const MenuContainer = (props) => {
  const { data: dashboardData } = useSelector((state) => state.dashboard);
  const navigate = useNavigate();

  const [selectedMenu, setSelectedMenu] = useState(menuItem[0]);
  const [selectedChildMenu, setSelectedChildMenu] = useState(null);
  const [currentParentMenu,setCurrentParentMenu]=useState(selectedMenu)
  const screenSize = useScreenSize();

   

  // Define the labels for direct navigation
  const directNavigationLabels = {
    // "Insights & Updates": "/insights",
    "Projects": "/project-listing",
    "Clients": "/clients",
    "Job Postings": "/careers",
  };

  useEffect(() => {
    if (selectedChildMenu?.path) {
      navigate(selectedChildMenu?.path);
      props.isMenuSelected();
    }
  }, [selectedChildMenu]);

  const handleParentMenuChange = (menu) => {

   

   
    if (!menu) {
    
      setSelectedMenu(null);
      setSelectedChildMenu(null); 

      return;
    }

    const path = directNavigationLabels[menu.label];
    if (path) {
      // Direct navigation for specific labels
      navigate(path);

      props.isMenuSelected();
    } else {
      // Otherwise, set selected menu normally
      setSelectedMenu(menu);
      setCurrentParentMenu(menu);
      
    }
  };


  const menuItemTemplate = (option) => {
    // console.log('option.items123:', option.items);
    const isDirectNavigation = !!directNavigationLabels[option.label];
    return (
    
      <div className="grid  mainNavbarMenu  ">
        <div className="col-10 label mainNavbarMenuContent navbarPaddingAdjust">{option.label}</div>
     
        {option.items && (
          <div className="col-2 text-right">
            {!isDirectNavigation && option.items && (
              <i className="pi pi-angle-right" />
            )}
          </div>
        )}
      </div>

    );
  };
  const menuItemTemplate1 = (option) => {
    // console.log('option.items123:', option.items);
    const isDirectNavigation = !!directNavigationLabels[option.label];
    return (

      <div className="grid  mainNavbarMenu1">
           
        <div className="col-10 label mainNavbarMenuContent1">{option.label}</div>
        {option.items && (
          <div className="col-2 text-right ">
            {!isDirectNavigation && option.items && (
              <i className="pi pi-angle-right" />
            )}
          </div>
        )}
      </div>
    );
  };

  const AccordionHeader = (menuObj) => {
    return (
      <span className="flex align-items-center gap-2 w-full">
        <span className="white-space-nowrap">{menuObj.label}</span>
      </span>
    );
  };

  return (

    <div className="absolute
   w-full
      top-menu z-5 border-top-1 " style={{ marginTop: '0px', backgroundColor: '#F5F4F1' }}  >
      {screenSize < 768 ? (
        <CustomAccordianDiv className="card " style={{ marginTop: '-10px' }}>
          <Accordion
            // style={{width:'100%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'space-between'}}
            multiple={true}
            collapseIcon={
              <i
                className="pi pi-angle-up"
                style={{ fontSize: "1.2rem", marginRight: "3px" }}
              ></i>
            }
            expandIcon={
              <i
                className="pi pi-angle-down"
                style={{ fontSize: "1.2rem", marginRight: "3px" }}
              ></i>
            }
            transitionOptions={{ timeout: 0 }}
          >
            {menuItem &&
              menuItem.map((menuObj, index) => {
                return (
                  <AccordionTab header={AccordionHeader(menuObj)} key={index} style={{ width: '100%' }}>

                    <ListBox
                      value={selectedChildMenu}
                      onChange={(e) => setSelectedChildMenu(e.value)}
                      options={menuObj?.items}
                      optionLabel="label"
                      className="w-full bg-transparent border-none shadow-none border-noround p-0"
                      itemTemplate={menuItemTemplate}
                      style={{ fontWeight: "500", marginLeft: "-20px" }}
                    />
                  </AccordionTab>
                );
              })}
          </Accordion>
        </CustomAccordianDiv>
      ) : (

        <div className="container " style={{}}>
          <div className="" style={{ width: '110%', marginLeft: '-62px' }}>
            <MenuContainerDiv className="grid1  " style={{}}  >
              <div className="container  p-0 ml-0 ">
                <div className="grid1 " style={{ display: 'flex' }}>
                  <div className="lg:col-4 md:col-12 sm:col-12  p-0" >

                    <div className="inner-box  "   >
                     
                      <ListBox
                        value={selectedMenu}
                        onChange={(e) => handleParentMenuChange(e.value)}
                        options={menuItem}
                        optionLabel="label"
                        className="w-full  border-none shadow-none border-noround p-0 "
                        itemTemplate={menuItemTemplate}
                        style={{ fontWeight: "500", color: '#000' }}
                      />
                    </div>
                  </div>

                  <div className="lg:col-4 md:col-12 sm:col-12 bg-lightgray p-0" >
                    <div className="inner-box">
                      {selectedMenu && !directNavigationLabels[selectedMenu.label] && (
                        <ListBox
                          value={selectedChildMenu}
                          onChange={(e) => setSelectedChildMenu(e.value)}
                          options={selectedMenu?.items}
                          optionLabel="label"
                          className="w-full m-0 border-none shadow-none border-noround   "
                          itemTemplate={menuItemTemplate1}
                          itemStyle={{ width: '100%', margin: 0, padding: 0, }}
                          style={{ backgroundColor: "#F5F4F1", fontWeight: "500", width: '100%', padding: 0, margin: 0 }}
                        />
                      )}
                    </div>
                  </div>
                  <div
                    className="lg:col-4 md:col-12 sm:col-12 text-left p-0"
                    style={{
                      // backgroundColor:'red',
                      //  backgroundColor:'#F5F4F1',
                      display: "flex",
                      justifySelf: 'center',
                      // flexDirection: "column",
                      gap: "5px",
                      marginTop: '18px',
                      marginLeft: '58px'
                      // alignItems: 'center',
                      // justifyContent: "flex-start"
                      // marginLeft:'50px'
                    }}
                  >
                    <div style={{ width: '100%', height: '100%', display: "flex", alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'column', gap: '5px' }}>
                      <div className="" style={{ width: '80%' }}>
                        <span
                          style={{
                            fontSize: "18px",
                            color: "#444",
                            fontWeight: "550",
                            letterSpacing: "2px",
                            lineHeight: "20px",
                            textTransform: "uppercase",
                          }}
                        >
                          {dashboardData?.featured_title || "Featured content"}
                        </span>
                      </div>

                      <div className="" style={{ width: "80%", height: '70%', }}>
                        <img
                          src={
                            dashboardData?.featured_img ||
                            "media/home_banners.png"
                          }
                          alt={dashboardData?.featured_title || "Featured"}
                          className=""
                          style={{ width: '100%', height: '100%' }}
                        />
                      </div>

                      <div className="" style={{ width: '80%' }}>
                        <span
                          style={{
                            fontSize: "16px",
                            color: "#444",
                            fontWeight: "500",
                            // letterSpacing: "1.5px",
                            // lineHeight: "20px",
                            textAlign: 'left',
                            textJustify: 'none'

                          }}
                          className="fontAvo"
                        >
                          {dashboardData?.featured_description ||
                            "Hertz: Quantum’s Flexible Capital at Work"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </MenuContainerDiv>
          </div>
        </div>

      )}
    </div>
  );
};
